import classNames from "classnames"
import React from "react"

import GatsbyStoryblokImage from "./GatsbyStoryblokImage"
import NumberDisplay from "./NumberDisplay"
import Typography from "./Typography"

import { Color } from "@constants/V2/color"

export interface NumberCalloutProps {
  icon?: string
  amount: string
  amountPrefix?: string
  amountSuffix?: string
  text: string
  isAnimated?: boolean
  className?: string
  textColor?: Color
}

const NumberCallout = ({
  icon,
  amount,
  amountPrefix,
  text,
  isAnimated,
  className,
  textColor = Color.Black,
}: NumberCalloutProps) => {
  return (
    <div className={classNames("flex items-center gap-8", className)}>
      {icon && <GatsbyStoryblokImage image={icon} alt="Trusted stamp" />}

      <NumberDisplay
        type="price"
        size="matchFont"
        valueFontSize="lead-sm"
        adornmentText={amountPrefix ?? ""}
        adornmentTextPosition="left"
        value={amount}
        enableThousandSeparator
        textColor={textColor}
        countUpOnView={isAnimated}
      />

      <Typography
        text={text}
        size="body-md"
        weight="book"
        font="grotesk"
        color={textColor}
      />
    </div>
  )
}

export default NumberCallout
